import 'babel-polyfill';
import React from 'react';
import { render } from 'react-dom';
import configureStore from '../common/store/configureStore';
import { browserHistory } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';
import Root from '../common/components/Root';
import Immutable from 'immutable';

require('../sass/style.scss');

const store = configureStore({ luraschi: Immutable.fromJS(window.INITIAL__STATE).get('luraschi') });
const history = syncHistoryWithStore(browserHistory, store);
const rootElement = document.getElementById('app');

render(
  <Root store={store} history={history} />,
  rootElement
);



// WEBPACK FOOTER //
// ./client/index.js